import React from 'react';
import { connect } from 'react-redux';
import { Typography } from '@drone-js/core';
import { mapStateToProps, SuggestedRouteModularProps } from 'component/page/detail/MoreInfoSections/SuggestedRoute/SuggestedRoute.selectors';
import { ActivitiesSuggestedRouteContainerSeenEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesSuggestedRouteContainerSeenEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import AgodaMarkdown from 'component/common/AgodaMarkdown/AgodaMarkdown';
import { InView } from 'react-intersection-observer';

const SuggestedRouteModular: React.FC<SuggestedRouteModularProps> = (props) => {
    const { suggestedRoute } = props;
    const isShowSuggestedRoute = !!suggestedRoute && suggestedRoute.length > 0;

    const onSeen = (inView: boolean) => {
        if (inView && isShowSuggestedRoute) {
            trackElementEvent<ActivitiesSuggestedRouteContainerSeenEventActivitiesFieldsV1>(ActivitiesSuggestedRouteContainerSeenEventActivitiesManifestV1.ids, {
                is_toggle_on: true,
            });
        }
    };

    if (!isShowSuggestedRoute) {
        return null;
    }

    return (
        <InView onChange={onSeen} triggerOnce={true} threshold={1}>
            {props.suggestedRoute?.map((sr, index) => (
                <Typography key={index} variant="body-s" lang={props.contentLocale} textColor="base.subtle" tag="span">
                    <AgodaMarkdown dataElementName="suggested-route-description" input={sr.description || ''} />
                </Typography>
            ))}
        </InView>
    );
};
SuggestedRouteModular.displayName = 'SuggestedRouteModular';

export default connect(mapStateToProps)(SuggestedRouteModular);
